var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo001A72(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#001a72;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_001a72") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_4_\\u043A\\u043E\\u043F\\u0438\\u044F_",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 4 (\\u043A\\u043E\\u043F\\u0438\\u044F)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 42,
    height: 42
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21,
    cy: 21,
    r: 18.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.88,7.5H13.13a2.73,2.73,0,0,0-2.63,2.77V31.82a2.65,2.65,0,0,0,2.63,2.68H28.88a2.65,2.65,0,0,0,2.62-2.68V10.27A2.73,2.73,0,0,0,28.88,7.5Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_7",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.69,9.5a.89.89,0,0,1,.81.94V31.66a.8.8,0,0,1-.81.84H13.31a.8.8,0,0,1-.81-.84V10.44a.89.89,0,0,1,.81-.94H28.69m0-1H13.31a1.88,1.88,0,0,0-1.81,1.94V31.66a1.81,1.81,0,0,0,1.81,1.84H28.69a1.81,1.81,0,0,0,1.81-1.84V10.44A1.88,1.88,0,0,0,28.69,8.5Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_8",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21 26.9 18 26.9 18 37.9 21 35.59 24 37.9 24 26.9 21 26.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.52,29.4v7.73L21,35.19l-2.52,1.94V29.4a3.45,3.45,0,0,1-1-2.07V39.08L21,36.4l3.48,2.68V27.33A3.45,3.45,0,0,1,23.52,29.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 21,
    cy: 26.97,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21,23.47A3.5,3.5,0,1,1,17.5,27a3.5,3.5,0,0,1,3.5-3.5m0-1A4.48,4.48,0,1,0,25.48,27,4.48,4.48,0,0,0,21,22.5Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_5",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.5,
    y: 11.5,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.5,
    y: 15.5,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.5,
    y: 19.5,
    width: 11,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo001A72);
export default __webpack_public_path__ + "static/media/logo_001a72.bfaa4e265f9a95abfc8a61a803e4d860.svg";
export { ForwardRef as ReactComponent };